var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"flex flex-row h-screen bg-white"},[_c('div',{staticClass:"flex flex-col w-full h-full"},[_c('div',{staticClass:"h-full"},[_c('child',{staticClass:"p-4-x",staticStyle:{"border-top":"1px solid #adc2ea"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }